import { PlanGate } from "@/components/plan-gate.tsx";
import { TeamsOverview } from "@/components/teams/teams-overview.tsx";
import { m } from "@/paraglide/messages.js";
import { organizationMembersStatsQueryOptions } from "@/services/members-service";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

/**
 * Teams, for everyone in the organization: an admin manages them here, a
 * member reads the teams they belong to (the page renders read-only for a
 * non-admin, as it did under /dashboard/teams). That is why it sits outside the
 * admin-only /settings/org subtree. /dashboard/teams stays as a redirect.
 */
export const Route = createFileRoute("/_authenticated/settings/teams/")({
	// Gateway is single-user — `teams: false` in PLANS.gateway. Send Gateway
	// users back to the dashboard instead of letting PlanGate pass them through
	// to the Teams UI (PlanGate now short-circuits Gateway as a parallel tier,
	// so the per-route guard is the access control for this surface).
	beforeLoad: ({ context }) => {
		if (context.auth.user?.orgPlan === "gateway") {
			throw redirect({ to: "/dashboard" });
		}
	},
	component: RouteComponent,
	loader: ({ context: { queryClient } }) => {
		queryClient.prefetchQuery(organizationMembersStatsQueryOptions());
	},
	head: () => ({
		meta: [{ title: pageTitle(m.teams_title()) }],
	}),
});

function RouteComponent() {
	return (
		<PlanGate
			requiredPlan="starter"
			featureName={m.plan_gate_feature_teams()}
			description={m.plan_gate_desc_teams()}
			benefits={[
				m.plan_gate_benefit_teams_roles(),
				m.plan_gate_benefit_teams_sso(),
				m.plan_gate_benefit_teams_permissions(),
			]}
		>
			<TeamsOverview />
		</PlanGate>
	);
}
